<template>
  <section id="home-frames" v-home-reveal class="frames" :aria-label="t('homeFramesTitle')">
    <div class="frames-head">
      <div class="frames-copy">
        <p class="kicker">{{ t('instantFramedPhotos') }}</p>
        <h2>{{ t('homeFramesTitle') }}</h2>
        <p>{{ t('homeFramesText') }}</p>
      </div>
      <router-link class="more" to="/signUp">{{ t('seeMore') }}</router-link>
    </div>

    <div class="grid home-stagger">
      <figure v-for="frame in frames" :key="frame.titleKey">
        <div class="photo">
          <img :src="frame.src" :alt="t(frame.titleKey)" />
        </div>
        <figcaption>{{ t(frame.titleKey) }}</figcaption>
      </figure>
    </div>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { HOME_FRAMES } from './home.data';
import { vHomeReveal } from './home-reveal';

export default defineComponent({
  directives: {
    homeReveal: vHomeReveal,
  },
  setup() {
    const { t } = useI18n();

    return {
      t,
      frames: HOME_FRAMES,
    };
  },
});
</script>
<style scoped lang="scss">
.frames {
  margin: 0 0 72px;
  scroll-margin-top: 88px;
}

.frames-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin: 0 0 28px;
}

.frames-copy {
  max-width: 46ch;
  text-align: left;
}

.kicker {
  margin: 0 0 10px;
  font-size: 11px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(246, 243, 238, 0.48);
}

.frames-copy h2 {
  margin: 0 0 8px;
  font-size: clamp(1.55rem, 3.2vw, 2.2rem);
  font-weight: 600;
  letter-spacing: -0.04em;
}

.frames-copy p:last-child {
  margin: 0;
  font-size: 1rem;
  line-height: 1.55;
  color: rgba(246, 243, 238, 0.76);
}

.more {
  flex-shrink: 0;
  margin-bottom: 4px;
  font-size: 13px;
  color: rgba(246, 243, 238, 0.72);
}

.more:hover {
  color: #f6f3ee;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px 28px;
}

.grid figure {
  margin: 0;
  width: 100%;
  text-align: center;
}

.photo {
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 50%;
  background: #141018;
}

.photo img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.grid figcaption {
  margin-top: 12px;
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(246, 243, 238, 0.82);
}

@media (max-width: 700px) {
  .frames-head {
    flex-direction: column;
    align-items: flex-start;
  }

  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px 14px;
  }
}
</style>
